// ajay:code all 27-08-26
import { Trash2 } from "lucide-react";

const textInput = {
  width: "100%",
  padding: "5px 8px",
  fontSize: 12,
  borderRadius: 6,
  border: "1px solid var(--border2)",
  background: "var(--surface2)",
  color: "var(--text)",
};

const fieldLabel = {
  fontSize: 10,
  color: "var(--text3)",
  fontWeight: 700,
  marginBottom: 3,
};

function Field({
  label,
  value,
  onChange,
  readOnly,
  textarea,
  rows = 2,
  placeholder,
}) {
  return (
    <div>
      <div style={fieldLabel}>{label}</div>
      {readOnly ? (
        <div style={{ fontSize: 12, whiteSpace: "pre-wrap" }}>
          {value || "—"}
        </div>
      ) : textarea ? (
        <textarea
          rows={rows}
          value={value || ""}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
          style={textInput}
        />
      ) : (
        <input
          type="text"
          value={value || ""}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
          style={textInput}
        />
      )}
    </div>
  );
}

export default function MethodRow({
  method: m,
  index,
  onChange,
  onDelete,
  readOnly,
}) {
  const set = (field, value) => onChange({ ...m, [field]: value });

  return (
    <div
      style={{
        background: "var(--surface2)",
        border: "1px solid var(--border2)",
        borderRadius: 6,
        padding: 10,
        marginTop: 8,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 6,
        }}
      >
        <span
          style={{
            fontSize: 10,
            fontWeight: 700,
            color: "var(--text3)",
            textTransform: "uppercase",
          }}
        >
          Method {index + 1}
        </span>
        {!readOnly && (
          <button
            type="button"
            title="Delete method"
            onClick={onDelete}
            style={{
              background: "none",
              border: "none",
              color: "var(--danger)",
              cursor: "pointer",
              display: "flex",
            }}
          >
            <Trash2 size={13} />
          </button>
        )}
      </div>

      <div
        style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr", gap: 10 }}
      >
        <Field
          label="Technique of Evaluation / Measurement"
          value={m.evaluation_technique}
          onChange={(v) => set("evaluation_technique", v)}
          readOnly={readOnly}
        />
        <Field
          label="Sample Size"
          value={m.sample_size}
          onChange={(v) => set("sample_size", v)}
          readOnly={readOnly}
        />
        <Field
          label="Sample Frequency"
          value={m.sample_frequency}
          onChange={(v) => set("sample_frequency", v)}
          readOnly={readOnly}
        />
      </div>

      <div style={{ marginTop: 8 }}>
        <Field
          label="Error Proofing"
          value={m.error_proofing}
          onChange={(v) => set("error_proofing", v)}
          readOnly={readOnly}
          textarea
        />
      </div>

      <div style={{ marginTop: 8 }}>
        <div style={fieldLabel}>Controlled By</div>
        <div style={{ display: "flex", gap: 12, marginTop: 4 }}>
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: 4,
              fontSize: 12,
            }}
          >
            <input
              type="checkbox"
              disabled={readOnly}
              checked={Boolean(m.controlled_by_worker)}
              onChange={(e) => set("controlled_by_worker", e.target.checked)}
            />
            W
          </label>
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: 4,
              fontSize: 12,
            }}
          >
            <input
              type="checkbox"
              disabled={readOnly}
              checked={Boolean(m.controlled_by_inspector)}
              onChange={(e) => set("controlled_by_inspector", e.target.checked)}
            />
            I
          </label>
        </div>
      </div>
    </div>
  );
}
